import {handleContactInfoSubmission} from 'screens/InsomniaSurvey/utils/accountCreation';
import {assertAdultDob} from './helpers';

export const handleSleepioContactInfoSubmission = async (surveyData: any) => {
  assertAdultDob(surveyData.dob ?? '');
  await handleContactInfoSubmission(surveyData);
};
